import { Parameter } from "../types/parameters";

export type HeatingTechnologyForAvailability = { id: string };

function totalSpecificCostParameterId(technologyId: string): string {
  return `${technologyId}TotalSpecificCost`;
}

/**
 * Heating technologies that are not calculated are omitted from the
 * calculation API response. A technology is calculated when its TotalSpecificCost parameter ({id}TotalSpecificCost) is not null.
 */
export function isCalculated(
  technology: HeatingTechnologyForAvailability,
  parameters: Parameter[]
): boolean {
  if (!parameters.some((p) => p.id.startsWith(technology.id))) {
    return false;
  }
  const totalSpecificCost = parameters.find(
    (p) => p.id === totalSpecificCostParameterId(technology.id)
  );
  if (totalSpecificCost?.value === null) {
    return false;
  }
  return true;
}
